<template>
  <v-tab-item :value="$route.path" class="pa-3">
    <v-row no-gutters align="center" class="pa-5 pt-0">
      <v-col cols="auto">
        <v-img src="@/assets/products.png" width="60" height="60"></v-img>
      </v-col>

      <v-col cols="9" class="pl-5">
        <h4 v-text="translations.title[lang]"></h4>
        <div style="font-size: 0.875rem" class="font-weight-medium mt-1">
          {{ translations.info[lang] }}
          <router-link
            class="blue--text mx-1"
            v-text="translations.productsPerStore[lang]"
            :to="`/${lang}/loyaltyPanel/products/products-per-store`"
          ></router-link>
          {{ translations.tab[lang] }}.
        </div>
      </v-col>
    </v-row>

    <v-toolbar flat height="90">
      <v-btn
        :disabled="!getPermission('products.create')"
        color="secondary"
        class="text-capitalize px-5"
        depressed
        v-text="translations.addProduct[lang]"
        @click="open('create', {})"
      ></v-btn>

      <v-btn
        :disabled="!getPermission('products.create')"
        color="secondary"
        class="text-capitalize px-5 ml-5"
        depressed
        v-text="translations.importCsvProducts[lang]"
        @click="openCsvInput"
      ></v-btn>
    </v-toolbar>
    <v-row no-gutters justify="end" class="px-4 pb-3 align-end">
      <div class="mr-auto">
        <ExportLinks export-key="company-products" :filters="{ q: search || '' }" />
      </div>
      <div class="mr-3">
        <v-btn
          v-if="!selectedProducts.length"
          color="secondary"
          class="text-capitalize px-5"
          depressed
          v-text="translations.editBytag[lang]"
          @click="open('update', {}, 'Tags')"
        ></v-btn>
        <v-btn
          v-else
          color="secondary"
          class="text-capitalize px-5"
          depressed
          v-text="translations.editSelected[lang]"
          @click="open('update', {}, 'Ids')"
        ></v-btn>
      </div>
      <!-- <v-spacer></v-spacer> -->

      <v-col cols="4" class="pa-0">
        <b-search-field
          v-model="search"
          :selectedSearchType="selectedSearchType"
          :searchTypes="searchTypes"
        ></b-search-field>
      </v-col>
    </v-row>

    <v-data-table
      v-model="selectedProducts"
      item-key="product_id"
      :headers="headers"
      :items="products"
      :footer-props="{
        itemsPerPageOptions: [12],
        showCurrentPage: true,
        pageText: `${page * 12 - 11}-${
          page * 12 <= serverItemsLength ? page * 12 : serverItemsLength
        } ${translations.paginationText[lang]} ${serverItemsLength}`,
      }"
      :page.sync="page"
      :server-items-length="serverItemsLength"
      :loading="loading"
      disable-sort
      show-select
      class="b-outlined"
    >
      <template v-slot:item.image="{ item }">
        <v-img :src="item.image" width="70" v-if="item.image"></v-img>
        <div v-else>-</div>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-tooltip color="secondary" top>
          <template v-slot:activator="{ on }">
            <v-btn
              :disabled="!getPermission('products.update')"
              color="yellow darken-3"
              icon
              v-on="on"
              @click="open('update', item)"
            >
              <v-icon v-text="icons.mdiPencilOutline"></v-icon>
            </v-btn>
          </template>

          <span class="font-weight-bold" v-text="translations.update[lang]"></span>
        </v-tooltip>

        <v-tooltip color="secondary" top>
          <template v-slot:activator="{ on }">
            <v-btn
              :disabled="!getPermission('products.delete')"
              color="red"
              icon
              v-on="on"
              @click="
                () => {
                  product = item;
                  deleteDialog = true;
                }
              "
            >
              <v-icon v-text="icons.mdiClose"></v-icon>
            </v-btn>
          </template>

          <span class="font-weight-bold" v-text="translations.delete[lang]"></span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="600">
      <ProductForm
        :mode="mode"
        :bulk="bulk"
        :selected-products="selectedProducts"
        @cancel="dialog = false"
      />
    </v-dialog>

    <v-dialog v-model="csvDialog" max-width="600" eager>
      <b-card
        :title="translations.importCsvProducts[lang]"
        :loading="loading"
        :error-message="errorMessage"
        @cancel="cancelCsv"
        @submit="submitCsv"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
        :disabled="!csvValid"
      >
        <v-form ref="csvForm">
          <v-file-input
            ref="csvInput"
            class="mx-auto csv-input"
            rounded
            accept=".csv"
            show-size
            filled
            dense
            v-model="csvFile"
            clearable
            prepend-icon=""
            background-color="#2a30420c"
            solo
            validate-on-blur
            :rules="csvRules"
            @change="validateCsv"
          >
            <template v-slot:label>
              <div style="cursor: pointer">
                {{ translations.chooseCsv[lang] }}
              </div>
            </template>
            <template v-slot:prepend-inner class="mx-auto" style="right: 0">
              <v-icon medium color="secondary darken-2">mdi-file-delimited</v-icon>
            </template>
          </v-file-input>
        </v-form>
      </b-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="500">
      <b-card
        type="delete"
        :title="translations.deleteProduct[lang]"
        :submit-text="translations.delete"
        :loading="loading"
        :error-message="errorMessage"
        @cancel="deleteDialog = false"
        @submit="remove()"
      >
        <div class="subtitle-1 font-weight-medium pt-2 px-2">
          {{ translations.deleteConfirmationMessage[lang] }}
          <span class="font-weight-bold text--primary">{{ product.name[lang] }}</span
          >{{ translations.questionmark[lang] }}
        </div>
      </b-card>
    </v-dialog>
  </v-tab-item>
</template>

<script>
import { mdiPencilOutline, mdiClose } from '@mdi/js';

import { mapState, mapMutations, mapActions } from 'vuex';
import debounce from 'lodash/debounce';
import ProductForm from '@/components/loyaltyPanel/products/ProductForm.vue';
import translations from '@/utils/translations/loyaltyPanel/products/productsTab';
import ExportLinks from '@/components/general/ExportLinks.vue';

export default {
  name: 'ProductsTab',

  components: { ProductForm, ExportLinks },

  mixins: [translations],

  data() {
    return {
      icons: { mdiPencilOutline, mdiClose },
      searchTypes: ['Name', 'Description', 'Selling Price', 'Target Price', 'Wholesale Price'],
      selectedSearchType: 'All Fields',
      page: +this.$route.query.page,
      mode: 'create',
      search: '',
      csvDialog: false,
      csvFile: null,
      csvRules: [
        (v) => !!v || this.translations.fileRequired[this.lang],
        (v) => (v && v.size > 0) || this.translations.fileRequired[this.lang],
        (v) =>
          (v && v.name && v.name.length > 0 && v.name.slice(-4) == '.csv') ||
          this.translations.csvRequired[this.lang],
      ],
      csvValid: false,
      selectedProducts: [],
      bulk: '',
    };
  },

  computed: {
    ...mapState(['loading', 'errorMessage', 'serverItemsLength']),
    ...mapState('loyaltyPanel/products', ['products']),

    lang() {
      return this.$route.params.lang;
    },

    headers() {
      return [
        {
          text: this.translations.image[this.lang],
          value: 'image',
        },
        {
          text: this.translations.productName[this.lang],
          value: `name[${this.lang}]`,
        },
        {
          text: this.translations.productDescription[this.lang],
          value: `description[${this.lang}]`,
        },
        {
          text: 'SKU',
          value: 'sku_number',
        },
        {
          text: this.translations.sellingPrice[this.lang],
          value: 'retail_price',
        },
        {
          text: this.translations.wholesalePrice[this.lang],
          value: 'wholesale_price',
        },
        {
          text: this.translations.actions[this.lang],
          value: 'actions',
        },
      ];
    },
    // selectableProducts(){
    //     return this.products.map(product => ({...product, isSelectable:true}))
    // },

    dialog: {
      get() {
        return this.$store.state.dialog;
      },

      set(val) {
        this.setDialog(val);
      },
    },

    deleteDialog: {
      get() {
        return this.$store.state.deleteDialog;
      },

      set(val) {
        this.setDeleteDialog(val);
      },
    },

    product: {
      get() {
        return this.$store.state.loyaltyPanel.products.product;
      },

      set(val) {
        this.setItem(val);
      },
    },

    query() {
      let query = '?';

      for (let key in this.$route.query) {
        query += `${key}=${this.$route.query[key]}&`;
      }

      return query.slice(0, query.length - 1);
    },
  },

  methods: {
    ...mapMutations(['setDialog', 'setDeleteDialog', 'setResetSuccess', 'setResetValidation']),
    ...mapMutations('loyaltyPanel/products', ['setShowImageUpload', 'setShowWeekdays', 'setItem']),
    ...mapActions(['getPermission']),
    ...mapActions('loyaltyPanel/products', ['getItems', 'remove', 'uploadProductsCsv']),

    open(mode, item, bulk = '') {
      this.mode = mode;
      this.bulk = bulk;
      this.product = item;
      if (this.product.image) this.setShowImageUpload(true);
      else this.setShowImageUpload(false);
      if (this.product.availability_days.length) this.setShowWeekdays(true);
      else this.setShowWeekdays(false);
      setTimeout(() => this.setResetSuccess(true), 300);
      this.setResetValidation(true);
      this.dialog = true;
    },
    openCsvInput() {
      this.csvDialog = true;
      this.$nextTick(() => {
        this.$refs.csvInput.$el.firstChild.firstChild.children[1].children[2].click();
      });
    },
    validateCsv() {
      this.$refs.csvForm?.validate();
      this.csvValid = !!this.$refs.csvInput?.valid;
    },

    submitCsv() {
      if (this.csvValid) {
        this.uploadProductsCsv(this.csvFile);
        this.csvDialog = false;
        this.csvFile = null;
      }
    },
    cancelCsv() {
      this.csvFile = null;
      this.csvDialog = false;
    },

    handleSearch() {
      if (this.page != 1) {
        this.page = 1;
      } else {
        this.getItems(`?q=${this.search}`);
      }
    },
  },

  watch: {
    $route(val) {
      if (!val.query.page) {
        this.$router.replace({
          query: {
            page: 1,
            ...this.$route.query,
          },
        });
      }
      this.getItems(`${this.query}&q=${this.search}`);
    },

    page(page) {
      this.$router.replace({ query: { ...this.$route.query, page } });
    },

    search(val) {
      if (val == null) {
        this.getItems(this.query);
      } else {
        this.debouncedSearch();
      }
    },
  },

  beforeCreate() {
    if (!this.$route.query.page) {
      this.$router.replace({
        query: {
          page: 1,
          ...this.$route.query,
        },
      });
    }
  },

  created() {
    this.debouncedSearch = debounce(this.handleSearch, 500);
  },

  mounted() {
    this.getItems(this.query);
  },
};
</script>
<style>
.csv-input * {
  cursor: pointer;
}
</style>
